export default __webpack_public_path__ + "static/media/flash05.eb1c3eeb.png";